import { get } from 'lodash';
import DatadogHandler from 'utils/datadog';
import {
  msFetchAccountInfoByChild,
  msGetMonthlyFeeForEnquiry,
  msGetPaymentDetailsForEnquiry,
  msFetchEgiroDetailsByRegChild,
  msExportGiroPdf,
  msEmailGiroPdf,
  msCompleteGiroSetup,
  msGetECDAMonthlyFeeForEnquiry,
  msInitiateRefundForCancelledEcdaRegistration,
  msFetchEgiroDetailsByECDARegChild,
} from 'services/RegistrationsService';
import {
  msInitiateRefundForCancelledRegistration,
  msFetchAccountInfoByECDAReg,
  msGetAllBankBicCodes,
  msGetEcdaRegistrationInvoice,
  msPayRegistrationInvoiceByGiro,
  msFetchUserAccounts,
  msAddUserGiro,
  msFetchECDAEddaRedirection,
  msGetPaymentAccess,
} from 'services/FinanceService';
import { msAddBankBankAccountForRefund } from 'services/BankAccountService';
import { MutationBuilder, QueryBuilder } from '../../queryBuilder';
import { FEATURE_FLAGS } from '../../../utils/constants';
import SkRequest from '../BaseRequest';
import {
  actionHandlerWithFeatureFlag,
  parseGraphQLError,
} from '../../../utils';
import {
  FETCH_AVAILABLE_BANKS,
  FETCH_PAYMENT_SESSION,
  FETCH_USER_ACCOUNT_LISTING,
  FETCH_ENQUIRY_PAYMENT_DETAILS_BY_ID,
  FETCH_ENQUIRY_MONTHLY_PAYMENT_DETAILS_BY_ID,
  FETCH_ACCOUNT_INFO_BY_ENQUIRY,
  CLEAR_PAYMENT_SESSION,
  SET_GIRO_SETUP_STEP,
  CLEAR_GIRO_SETUP_STEP,
  FETCH_ACCOUNT_INFO_BY_REG,
  FETCH_ACCOUNT_INFO_BY_CHILD,
  FETCH_EGIRO_ACCOUNT_INFO_BY_REG,
  FETCH_EGIRO_ACCOUNT_INFO_BY_CHILD,
  FETCH_EGIRO_REDIRECTION,
  FETCH_ECDA_EGIRO_REDIRECTION,
  FETCH_ACCOUNT_INFO_BY_ECDA,
  FETCH_ACCOUNT_INFO_BY_ECDA_REG,
  FETCH_ECDA_ENQUIRY_MONTHLY_PAYMENT_DETAILS_BY_ID,
  FETCH_ECDA_ENQUIRY_PAYMENT_DETAILS_BY_ID,
  FETCH_EGIRO_ACCOUNT_INFO_BY_ECDA_REG,
} from '../actionTypes';
import apolloUtils, {
  handleResponseForApollo,
  SkApolloRequest,
} from '../../../utils/apolloUtils';
import {
  FIND_ACCOUNT_INFO_BY_CHILD_ID,
  GET_ACCOUNT_LISTING,
  ADD_GIRO,
  EXPORT_GIRO_PDF,
  EMAIL_GIRO_PDF,
  GET_PAYNOW_UEN_BY_SCHOOL,
  PAY_REGISTRATION_INVOICE_BY_GIRO,
  GET_PAYMENT_ACCESS,
  INITIATE_REFUND,
  MARK_GIRO_AS_COMPLETED,
  EGIRO_DETAILS_BY_REG_CHILD,
  EGIRO_DETAILS_BY_CHILD,
  EDDA_REDIRECTION,
  ECDA_EDDA_REDIRECTION,
  UPDATE_TRANSACTION_STATUS,
  ADD_BANK_ACCOUNT_FOR_REFUND,
  FIND_ECDA_ACCOUNT_INFO_BY_ID,
  GET_ECDA_REGISTRATION_INVOICE,
  EGIRO_DETAILS_BY_ECDA_REG_CHILD,
  INITIATE_REFUND_ECDA_REGISTRATION,
} from '../../models/Registration/paymentModels';

const fileName = 'src/redux/actions/Registration/Payment.js';
const _mMutationBuilder = new MutationBuilder();
const _mQueryBuilder = new QueryBuilder();

const mPaymentSessionDetails = {
  Id: 'string',
  Version: 'string',
  UpdateStatus: 'string',
  SuccessIndicator: 'string',
  MerchantId: 'string',
  Order: {
    Id: 'string',
    Amount: 'number',
    Currency: 'string',
    Description: 'string',
  },
};

_mMutationBuilder.setNewMutation(
  'createPaymentSession',
  mPaymentSessionDetails
);

_mQueryBuilder.setNewQuery('getPaymentSession', mPaymentSessionDetails);

_mMutationBuilder.setNewMutation('updatePaymentSession', {});

_mMutationBuilder.setNewMutation('payRegistrationFeeByGiro', {
  Success: 'boolean',
  TransactionNo: 'string',
  ErrorMessage: 'string',
});
_mMutationBuilder.setNewMutation('markRegistrationPaymentAsSuccessful', {});

_mMutationBuilder.setNewMutation('payGiroByInvoiceID', {});

_mQueryBuilder.setNewQuery('findAllBankBicCode', {
  data: {
    ID: 'number',
    bankCode: 'string',
    bankName: 'string',
    bicCode: 'string',
    displayOrder: 'number',
    isCdaSupported: 'boolean',
  },
});

_mQueryBuilder.setNewQuery('getRegistrationInvoice', {
  ID: 'number',
  totalAmount: 'number',
  outstandingAmount: 'number',
  invoiceNo: 'string',
  invoiceDate: 'datetime',
  invoiceDueDate: 'datetime',
  status: 'string',
  invoiceType: 'string',
  invoiceItems: {
    data: {
      ID: 'number',
      label: 'string',
      totalAmount: 'number',
      displayTotalAmount: 'string',
      displayAdjustedAmount: 'string',
      billableItem: {
        sn1StrAccPacAccountCode: 'string',
      },
    },
  },
  grandTotal: 'number',
  updatedAt: 'datetime',
  receipts: {
    data: {
      receiptNo: 'string',
      paymentType: 'string',
      amount: 'number',
      amountReceived: 'number',
      createdAt: 'datetime',
      updatedAt: 'datetime',
      documentNo: 'string',
      userByCollectedByFkStaff: {
        firstname: 'string',
        lastname: 'string',
      },
    },
  },
  sn1UpdatedBy: 'string',
  sn1VerifiedBy: 'string',
});

_mQueryBuilder.setNewQuery('getRegistrationDraftMonthlyFeeInvoice', {
  totalAmount: 'number',
  outstandingAmount: 'number',
  status: 'string',
  grandTotal: 'number',
  invoiceItems: {
    data: {
      label: 'string',
      totalAmount: 'number',
      displayTotalAmount: 'string',
      displayAdjustedAmount: 'string',
      billableItem: {
        type: 'string',
      },
    },
  },
});

_mQueryBuilder.setNewQuery('getEcdaRegistrationDraftMonthlyFeeInvoice', {
  totalAmount: 'number',
  outstandingAmount: 'number',
  status: 'string',
  grandTotal: 'number',
  invoiceItems: {
    data: {
      label: 'string',
      totalAmount: 'number',
      displayTotalAmount: 'string',
      displayAdjustedAmount: 'string',
      billableItem: {
        type: 'string',
      },
    },
  },
});

_mQueryBuilder.setNewQuery('bankAccountsByFkChild', {
  data: {
    ID: 'number',
    isCda: 'boolean',
    billReferenceNumber: 'string',
    payerAccountName: 'string',
    payerAccountNumber: 'string',
    payerBankBranch: 'string',
    status: 'string',
    active: 'bool',
    source: 'string',
    fkBankBicCode: 'string',
  },
});

_mQueryBuilder.setNewQuery('getTrialPeriodInvoice', {
  ID: 'number',
  invoiceNo: 'string',
  status: 'string',
  outstandingAmount: 'number',
  totalAmount: 'number',
});

_mQueryBuilder.setNewQuery('getPaymentAccess', {});

const dispatchFetchPaymentSession = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_PAYMENT_SESSION,
    key: 'paymentSession',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

export const dispatchClearPaymentSession =
  (data = {}) =>
  dispatch => {
    dispatch({
      type: CLEAR_PAYMENT_SESSION,
      key: 'paymentSession',
      value: data,
    });
  };

const dispatchAccountListing = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_USER_ACCOUNT_LISTING,
    key: 'accountListing',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchFetchAccountByEnquiry = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_ACCOUNT_INFO_BY_ENQUIRY,
    key: 'accountInfoByEnquiry',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchFetchAccountByReg = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_ACCOUNT_INFO_BY_REG,
    key: 'accountInfoByReg',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchFetchAccountByECDA = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_ACCOUNT_INFO_BY_ECDA,
    key: 'accountInfoByECDA',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchFetchAccountByECDAReg = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_ACCOUNT_INFO_BY_ECDA_REG,
    key: 'accountInfoByECDAReg',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchFetchEgiroDetailsByRegChild = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_EGIRO_ACCOUNT_INFO_BY_REG,
    key: 'egiroAccountByRegChild',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchFetchEgiroDetailsByECDARegChild = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_EGIRO_ACCOUNT_INFO_BY_ECDA_REG,
    key: 'egiroAccountByECDARegChild',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchFetchEgiroDetailsByFkChild = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_EGIRO_ACCOUNT_INFO_BY_CHILD,
    key: 'egiroAccountByChild',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchFetchEddaRedirection = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_EGIRO_REDIRECTION,
    key: 'egiroRedirection',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchFetchECDAEddaRedirection = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_ECDA_EGIRO_REDIRECTION,
    key: 'ecdaEgiroRedirection',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchFetchAccountByChild = (
  dispatch,
  inProgress = true,
  data = [],
  error = null
) => {
  dispatch({
    type: FETCH_ACCOUNT_INFO_BY_CHILD,
    key: 'accountInfoByChild',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchFetchAvailableBanks = (
  dispatch,
  inProgress = true,
  data = [],
  error = null
) => {
  dispatch({
    type: FETCH_AVAILABLE_BANKS,
    key: 'availableBanks',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchEnquiryMonthlyPaymentDetailsById = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_ENQUIRY_MONTHLY_PAYMENT_DETAILS_BY_ID,
    key: 'enquiryMonthlyPaymentDetailById',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchECDAMonthlyPaymentDetailsById = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_ECDA_ENQUIRY_MONTHLY_PAYMENT_DETAILS_BY_ID,
    key: 'ecdaMonthlyPaymentDetailById',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchRegistrationPaymentById = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_ENQUIRY_PAYMENT_DETAILS_BY_ID,
    key: 'registrationPaymentById',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchFetchECDARegistrationPaymentById = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_ECDA_ENQUIRY_PAYMENT_DETAILS_BY_ID,
    key: 'ecdaRegistrationPaymentById',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

export const getTrialInvoice = IDEnquiry => async () => {
  try {
    const data = await SkRequest({
      data: {
        query: _mQueryBuilder.getQueryAsString('getTrialPeriodInvoice', {
          IDEnquiry,
        }),
      },
      method: 'POST',
    });

    return data;
  } catch (ex) {
    return ex;
  }
};

export const monoFetchAvailableBanks = async () => {
  try {
    const data = await SkRequest({
      data: {
        query: _mQueryBuilder.getQueryAsString('findAllBankBicCode', {
          pagination: {
            sort: ['display_order', 'bankName'],
          },
        }),
      },
      method: 'POST',
    });

    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoFetchAvailableBanks',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: ex.message,
    };
  }
};

export const fetchAvailableBanks = () => async dispatch => {
  dispatchFetchAvailableBanks(dispatch);
  const data = await actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      dispatch,
      msHandler: _ =>
        msGetAllBankBicCodes(_, {
          pagination: { sort: ['display_order', 'bankName'] },
        }),
      monoHandler: monoFetchAvailableBanks,
    }
  );

  if (data.success) {
    dispatchFetchAvailableBanks(dispatch, false, { data: data.data });
  } else {
    dispatchFetchAvailableBanks(dispatch, false, null, data.error);
  }

  return data;
};

export const monoFetchUserAccounts =
  (_, { isCDA, paymentType }) =>
  async () => {
    const client = await apolloUtils();

    try {
      return client.query({
        query: GET_ACCOUNT_LISTING,
        variables: {
          isCDA,
          paymentType,
        },
      });
    } catch (ex) {
      DatadogHandler.addError(ex);
      DatadogHandler.sendLog(
        ex,
        {
          functionName: 'monoFetchUserAccounts',
          fileName,
        },
        'error'
      );
      return {
        success: false,
        error: ex.message,
      };
    }
  };

export const fetchUserAccounts =
  ({ isCDA, paymentType }) =>
  async dispatch => {
    try {
      dispatchAccountListing(dispatch);
      const data = await actionHandlerWithFeatureFlag(
        FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
        {
          dispatch,
          msHandler: msFetchUserAccounts,
          monoHandler: monoFetchUserAccounts,
          extraData: { isCDA, paymentType },
        }
      );
      if (!data.loading && get(data, 'data.getRegistrationAccountListing')) {
        dispatchAccountListing(dispatch, false, { data: data.data });
      } else {
        dispatchAccountListing(dispatch, false, null, data.errors);
      }
      return data;
    } catch (ex) {
      return ex;
    }
  };

export const monoGetMonthlyFeeForEnquiry = async (_, reqData) => {
  try {
    const IDRegistration = get(reqData, 'IDRegistration');
    const data = await SkRequest({
      data: {
        query: _mQueryBuilder.getQueryAsString(
          'getRegistrationDraftMonthlyFeeInvoice',
          {
            IDRegistration,
          }
        ),
      },
      method: 'POST',
    });

    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetMonthlyFeeForEnquiry',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: ex.message,
    };
  }
};

export const getMonthlyFeeForEnquiry = IDRegistration => async dispatch => {
  dispatchEnquiryMonthlyPaymentDetailsById(dispatch);
  const data = await actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      dispatch,
      msHandler: msGetMonthlyFeeForEnquiry,
      monoHandler: monoGetMonthlyFeeForEnquiry,
      extraData: { IDRegistration },
    }
  );
  if (data.success) {
    dispatchEnquiryMonthlyPaymentDetailsById(dispatch, false, {
      data: data.data,
    });
  } else {
    dispatchEnquiryMonthlyPaymentDetailsById(dispatch, false, null, data.error);
  }

  return data;
};

export const monoGetPaymentDetailsForEnquiry = async (_, reqData) => {
  try {
    const registrationID = get(reqData, 'registrationID');
    const data = await SkRequest({
      data: {
        query: _mQueryBuilder.getQueryAsString('getRegistrationInvoice', {
          IDRegistration: registrationID,
        }),
      },
      method: 'POST',
    });

    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetPaymentDetailsForEnquiry',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: ex.message,
    };
  }
};

export const getPaymentDetailsForEnquiry = registrationID => async dispatch => {
  dispatchRegistrationPaymentById(dispatch);
  const data = await actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      dispatch,
      msHandler: msGetPaymentDetailsForEnquiry,
      monoHandler: monoGetPaymentDetailsForEnquiry,
      extraData: { registrationID },
    }
  );
  if (data.success) {
    dispatchRegistrationPaymentById(dispatch, false, {
      data: data.data,
      key: 'registrationPaymentById',
    });
  } else {
    dispatchRegistrationPaymentById(dispatch, false, null, data.error);
  }
  return data;
};

export const monoGetECDAPaymentDetailsForEnquiry = async (_, reqData) => {
  try {
    const registrationID = get(reqData, 'registrationID');
    return SkApolloRequest({
      params: {
        query: GET_ECDA_REGISTRATION_INVOICE,
        variables: {
          IDRegistration: registrationID,
        },
      },
      type: 'query',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetECDAPaymentDetailsForEnquiry',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const getECDAPaymentDetailsForEnquiry =
  registrationID => async dispatch => {
    dispatchFetchECDARegistrationPaymentById(dispatch);
    const resp = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetEcdaRegistrationInvoice,
        monoHandler: monoGetECDAPaymentDetailsForEnquiry,
        extraData: { registrationID },
      }
    );
    if (resp.success) {
      dispatchFetchECDARegistrationPaymentById(dispatch, false, {
        data: resp.data,
        key: 'ecdaRegistrationPaymentById',
      });
    } else {
      dispatchFetchECDARegistrationPaymentById(
        dispatch,
        false,
        null,
        resp.error
      );
    }
    return resp;
  };

export const getPaymentSession = paymentOrderID => async dispatch => {
  dispatchFetchPaymentSession(dispatch);

  try {
    const data = await SkRequest({
      data: {
        query: _mQueryBuilder.getQueryAsString('getPaymentSession', {
          paymentOrderID,
        }),
      },
      method: 'POST',
    });

    if (data.success) {
      dispatchFetchPaymentSession(dispatch, false, { data: data.data });
    } else {
      dispatchFetchPaymentSession(dispatch, false, null, data.error);
    }

    return data;
  } catch (ex) {
    dispatchFetchPaymentSession(dispatch, false, null, {
      error: ex.message,
    });
    return ex;
  }
};

export const updatePaymentSession = paymentOrderID => async () => {
  try {
    return await SkRequest({
      data: {
        query: _mMutationBuilder.getMutationAsString('updatePaymentSession', {
          paymentOrderID,
        }),
      },
      method: 'POST',
    });
  } catch (ex) {
    return ex;
  }
};

export const createPaymentSession = InvoiceID => async () => {
  try {
    return await SkRequest({
      data: {
        query: _mMutationBuilder.getMutationAsString('createPaymentSession', {
          InvoiceID,
        }),
      },
      method: 'POST',
    });
  } catch (ex) {
    return ex;
  }
};

export const payUserGiro = reqData => async () => {
  try {
    return await SkRequest({
      data: {
        query: _mMutationBuilder.getMutationAsString(
          'payGiroByInvoiceID',
          reqData
        ),
      },
      method: 'POST',
    });
  } catch (ex) {
    throw ex;
  }
};

export const monoCompleteGiroSetup = async (_, reqData) => {
  try {
    const { IDRegistration } = reqData;
    return await SkApolloRequest({
      params: {
        mutation: MARK_GIRO_AS_COMPLETED,
        variables: { IDRegistration },
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoCompleteGiroSetup',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const completeGiroSetup = IDRegistration => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msCompleteGiroSetup,
      monoHandler: monoCompleteGiroSetup,
      extraData: { IDRegistration },
    }
  );
};

export const monoAddUserGiro = async (_, reqData) => {
  try {
    const { giroAccount, paymentType } = reqData;
    const client = await apolloUtils();
    return await client.mutate({
      mutation: ADD_GIRO,
      variables: {
        giroAccount,
        paymentType,
      },
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoAddUserGiro',
        fileName,
      },
      'error'
    );
    throw ex;
  }
};

export const addUserGiro =
  ({ giroAccount, paymentType }) =>
  async () => {
    return actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        msHandler: msAddUserGiro,
        monoHandler: monoAddUserGiro,
        extraData: { giroAccount, paymentType },
      }
    );
  };

export const getPayNowUENBySchool = schoolID => async () => {
  const client = await apolloUtils();
  try {
    return await client.query({
      query: GET_PAYNOW_UEN_BY_SCHOOL,
      variables: { schoolID },
    });
  } catch (ex) {
    throw ex;
  }
};

export const monoFetchAccountInfoByChild = async (_, reqData) => {
  const client = await apolloUtils();

  try {
    const regChildId = get(reqData, 'regChildId');
    const result = await client.query({
      query: FIND_ACCOUNT_INFO_BY_CHILD_ID,
      variables: {
        regChildId,
      },
    });
    return handleResponseForApollo(result);
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoFetchAccountInfoByChild',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const fetchAccountInfoByEnquiry = regChildId => async dispatch => {
  dispatchFetchAccountByEnquiry(dispatch);
  const result = await actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      dispatch,
      msHandler: msFetchAccountInfoByChild,
      monoHandler: monoFetchAccountInfoByChild,
      extraData: { regChildId },
    }
  );
  if (result.success) {
    dispatchFetchAccountByEnquiry(dispatch, false, result.data);
  } else {
    dispatchFetchAccountByEnquiry(dispatch, false, null, result.error);
  }
  return result;
};

export const fetchAccountInfoByReg = regChildId => async dispatch => {
  dispatchFetchAccountByReg(dispatch);
  const result = await actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      dispatch,
      msHandler: msFetchAccountInfoByChild,
      monoHandler: monoFetchAccountInfoByChild,
      extraData: { regChildId },
    }
  );

  if (result.success) {
    dispatchFetchAccountByReg(dispatch, false, result.data);
  } else {
    dispatchFetchAccountByReg(dispatch, false, null, result.error);
  }
  return result;
};

export const monoFetchAccountInfoByECDA = async (_, reqData) => {
  try {
    const IDEcdaRegChild = get(reqData, 'IDEcdaRegChild');
    return SkApolloRequest({
      params: {
        query: FIND_ECDA_ACCOUNT_INFO_BY_ID,
        variables: { IDEcdaRegChild },
      },
      type: 'query',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoFetchAccountInfoByECDA',
        fileName,
      },
      'error'
    );
    return {
      error: parseGraphQLError(ex),
    };
  }
};

export const fetchAccountInfoByECDAReg = IDEcdaRegChild => async dispatch => {
  dispatchFetchAccountByECDAReg(dispatch);
  const resp = await actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      dispatch,
      msHandler: msFetchAccountInfoByECDAReg,
      monoHandler: monoFetchAccountInfoByECDA,
      extraData: { IDEcdaRegChild },
    }
  );
  if (resp.success) {
    dispatchFetchAccountByECDAReg(dispatch, false, resp.data);
  } else {
    dispatchFetchAccountByECDAReg(dispatch, false, null, resp.error);
  }
  return resp;
};

export const fetchAccountInfoByECDA = IDEcdaRegChild => async dispatch => {
  dispatchFetchAccountByECDA(dispatch);
  const resp = await actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      dispatch,
      msHandler: msFetchAccountInfoByECDAReg,
      monoHandler: monoFetchAccountInfoByECDA,
      extraData: { IDEcdaRegChild },
    }
  );
  if (resp.success) {
    dispatchFetchAccountByECDA(dispatch, false, resp.data);
  } else {
    dispatchFetchAccountByECDA(dispatch, false, null, resp.error);
  }
  return resp;
};

export const fetchAccountInfoByChild = regChildId => async dispatch => {
  dispatchFetchAccountByChild(dispatch);
  const resp = await actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      dispatch,
      msHandler: msFetchAccountInfoByChild,
      monoHandler: monoFetchAccountInfoByChild,
      extraData: { regChildId, dispatchFetchAccountByChild },
    }
  );
  if (resp.success) {
    const data = get(resp, 'data.getBankAccountByFkRegistrationChild', []);
    dispatchFetchAccountByChild(dispatch, false, data);
  } else {
    dispatchFetchAccountByChild(dispatch, false, null, resp.error);
  }
  return resp;
};

export const monoPayRegistrationInvoiceByGiro = async (_, reqData) => {
  try {
    const IDRegChild = get(reqData, 'IDRegChild');
    const IDInvoice = get(reqData, 'IDInvoice');
    return SkApolloRequest({
      params: {
        query: PAY_REGISTRATION_INVOICE_BY_GIRO,
        variables: { IDRegChild, IDInvoice },
      },
      type: 'query',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoPayRegistrationInvoiceByGiro',
        fileName,
      },
      'error'
    );
    return { error: parseGraphQLError(ex) };
  }
};

export const payRegistrationInvoiceByGiro =
  ({ IDRegChild, IDInvoice }) =>
  async dispatch => {
    return actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msPayRegistrationInvoiceByGiro,
        monoHandler: monoPayRegistrationInvoiceByGiro,
        extraData: { IDRegChild, IDInvoice },
      }
    );
  };

export const monoGetPaymentAccess = async (dispatch, reqData) => {
  const client = await apolloUtils();
  try {
    const data = await client.query({
      query: GET_PAYMENT_ACCESS,
      variables: reqData,
    });
    return data;
  } catch (ex) {
    return ex;
  }
};

export const getPaymentAccess = reqData => async dispatch => {
  try {
    dispatchFetchPaymentSession(dispatch);
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetPaymentAccess,
        monoHandler: monoGetPaymentAccess,
        extraData: reqData,
      }
    );
    if (!data.loading && get(data, 'data.getRegistrationPaymentAccess')) {
      dispatchFetchPaymentSession(dispatch, false, { data: data.data });
    } else {
      dispatchFetchPaymentSession(dispatch, false, null, data.error);
    }
    return data;
  } catch (ex) {
    dispatchFetchPaymentSession(dispatch, false, null, {
      error: ex.message,
    });
    return ex;
  }
};

export const dispatchSetGiroSetupStep = data => dispatch => {
  dispatch({
    type: SET_GIRO_SETUP_STEP,
    key: 'giroSetupStepDetail',
    value: {
      inProgress: false,
      data,
      error: null,
    },
  });
};

export const dispatchClearGiroSetupStep =
  (data = {}) =>
  dispatch => {
    dispatch({
      type: CLEAR_GIRO_SETUP_STEP,
      key: 'giroSetupStepDetail',
      value: {
        inProgress: false,
        data,
        error: null,
      },
    });
  };

export const monoExportGiroPdf = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: EXPORT_GIRO_PDF,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoExportGiroPdf',
        fileName,
      },
      'error'
    );
    return {
      error: parseGraphQLError(ex),
    };
  }
};

export const exportGiroPdf = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msExportGiroPdf,
      monoHandler: monoExportGiroPdf,
      extraData: reqData,
    }
  );
};

export const monoEmailGiroPdf = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: EMAIL_GIRO_PDF,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoEmailGiroPdf',
        fileName,
      },
      'error'
    );
    return {
      error: parseGraphQLError(ex),
    };
  }
};

export const emailGiroPdf = reqData => () =>
  actionHandlerWithFeatureFlag(FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED, {
    msHandler: msEmailGiroPdf,
    monoHandler: monoEmailGiroPdf,
    extraData: reqData,
  });

export const monoInitiateRefundForCancelledRegistration = async (
  _,
  reqData
) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: INITIATE_REFUND,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoInitiateRefundForCancelledRegistration',
        fileName: 'redux/actions/Registration/Payment.js',
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const initiateRefundForCancelledRegistration = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msInitiateRefundForCancelledRegistration,
      monoHandler: monoInitiateRefundForCancelledRegistration,
      extraData: reqData,
    }
  );
};

export const monoInitiateRefundForCancelledEcdaRegistration = async (
  _,
  reqData
) => {
  try {
    return SkApolloRequest({
      params: {
        mutation: INITIATE_REFUND_ECDA_REGISTRATION,
        variables: reqData,
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoInitiateRefundForCancelledEcdaRegistration',
        fileName: 'redux/actions/Registration/Payment.js',
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const initiateRefundForCancelledEcdaRegistration =
  reqData => async () => {
    return actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        msHandler: msInitiateRefundForCancelledEcdaRegistration,
        monoHandler: monoInitiateRefundForCancelledEcdaRegistration,
        extraData: reqData,
      }
    );
  };

export const monoFetchEgiroDetailsByRegChild = async (_, reqData) => {
  try {
    const registrationChildId = get(reqData, 'registrationChildId');
    const result = await SkApolloRequest({
      params: {
        query: EGIRO_DETAILS_BY_REG_CHILD,
        variables: { registrationChildId },
      },
      type: 'query',
    });
    return result;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoFetchEgiroDetailsByRegChild',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const fetchEgiroDetailsByRegChild =
  registrationChildId => async dispatch => {
    dispatchFetchEgiroDetailsByRegChild(dispatch);
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msFetchEgiroDetailsByRegChild,
        monoHandler: monoFetchEgiroDetailsByRegChild,
        extraData: { registrationChildId },
      }
    );
    if (data.success) {
      dispatchFetchEgiroDetailsByRegChild(dispatch, false, data.data);
    } else {
      dispatchFetchEgiroDetailsByRegChild(dispatch, false, null, data.error);
    }
    return data;
  };

export const monoFetchEgiroDetailsByECDARegChild = async (_, reqData) => {
  try {
    const ecdaRegistrationChildId = get(reqData, 'ecdaRegistrationChildId');
    return SkApolloRequest({
      params: {
        query: EGIRO_DETAILS_BY_ECDA_REG_CHILD,
        variables: { ecdaRegistrationChildId },
      },
      type: 'query',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoFetchEgiroDetailsByECDARegChild',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const fetchEgiroDetailsByECDARegChild =
  ecdaRegistrationChildId => async dispatch => {
    dispatchFetchEgiroDetailsByECDARegChild(dispatch);
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msFetchEgiroDetailsByECDARegChild,
        monoHandler: monoFetchEgiroDetailsByECDARegChild,
        extraData: { ecdaRegistrationChildId },
      }
    );
    if (data.success) {
      dispatchFetchEgiroDetailsByECDARegChild(dispatch, false, data.data);
    } else {
      dispatchFetchEgiroDetailsByECDARegChild(
        dispatch,
        false,
        null,
        data.error
      );
    }
    return data;
  };

export const fetchEgiroDetailsByFkChild = childId => async dispatch => {
  dispatchFetchEgiroDetailsByFkChild(dispatch);
  try {
    const result = await SkApolloRequest({
      params: {
        query: EGIRO_DETAILS_BY_CHILD,
        variables: { childId },
      },
      type: 'query',
    });
    if (result.success) {
      dispatchFetchEgiroDetailsByFkChild(dispatch, false, result.data);
    } else {
      dispatchFetchEgiroDetailsByFkChild(dispatch, false, null, result.error);
    }
    return result;
  } catch (ex) {
    dispatchFetchEgiroDetailsByFkChild(dispatch, false, null, {
      error: parseGraphQLError(ex),
    });
  }
};

export const fetchEddaRedirection = reqData => async dispatch => {
  dispatchFetchEddaRedirection(dispatch);
  try {
    const result = await SkApolloRequest({
      params: {
        query: EDDA_REDIRECTION,
        variables: reqData,
      },
      type: 'query',
    });
    if (result.success) {
      dispatchFetchEddaRedirection(dispatch, false, result.data);
    } else {
      dispatchFetchEddaRedirection(dispatch, false, null, result.error);
    }
    return result;
  } catch (ex) {
    dispatchFetchEddaRedirection(dispatch, false, null, {
      error: parseGraphQLError(ex),
    });
  }
};

export const monoFetchECDAEddaRedirection = async (_, reqData) => {
  try {
    return await SkApolloRequest({
      params: {
        query: ECDA_EDDA_REDIRECTION,
        variables: reqData,
      },
      type: 'query',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoFetchECDAEddaRedirection',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const fetchECDAEddaRedirection = reqData => async dispatch => {
  dispatchFetchECDAEddaRedirection(dispatch);
  try {
    const result = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msFetchECDAEddaRedirection,
        monoHandler: monoFetchECDAEddaRedirection,
        extraData: reqData,
      }
    );
    if (result.success) {
      dispatchFetchECDAEddaRedirection(dispatch, false, result.data);
    } else {
      dispatchFetchECDAEddaRedirection(dispatch, false, null, result.error);
    }
    return result;
  } catch (ex) {
    dispatchFetchECDAEddaRedirection(dispatch, false, null, {
      error: parseGraphQLError(ex),
    });
  }
};

export const updateEgiroTransactionStatus = reqData => async () => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: UPDATE_TRANSACTION_STATUS,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    return ex;
  }
};

export const monoAddBackBankAccountForCancelledReg = async (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        mutation: ADD_BANK_ACCOUNT_FOR_REFUND,
        variables: reqData,
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoAddBackBankAccountForCancelledReg',
        fileName,
      },
      'error'
    );
    return {
      error: parseGraphQLError(ex),
    };
  }
};

export const addBankAccountRefundForCancelledReg = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msAddBankBankAccountForRefund,
      monoHandler: monoAddBackBankAccountForCancelledReg,
      extraData: reqData,
    }
  );
};

export const monoGetECDAMonthlyFeeForEnquiry = async (_, reqData) => {
  try {
    const IDRegistration = get(reqData, 'IDRegistration');
    return SkRequest({
      data: {
        query: _mQueryBuilder.getQueryAsString(
          'getEcdaRegistrationDraftMonthlyFeeInvoice',
          {
            IDRegistration,
          }
        ),
      },
      method: 'POST',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetECDAMonthlyFeeForEnquiry',
        fileName,
      },
      'error'
    );
    return {
      error: ex.message,
    };
  }
};

export const getECDAMonthlyFeeForEnquiry = IDRegistration => async dispatch => {
  dispatchECDAMonthlyPaymentDetailsById(dispatch);
  const resp = await actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      dispatch,
      msHandler: msGetECDAMonthlyFeeForEnquiry,
      monoHandler: monoGetECDAMonthlyFeeForEnquiry,
      extraData: { IDRegistration },
    }
  );

  if (resp.success) {
    dispatchECDAMonthlyPaymentDetailsById(dispatch, false, resp.data);
  } else {
    dispatchECDAMonthlyPaymentDetailsById(dispatch, false, null, resp.error);
  }

  return resp;
};

export default getPaymentAccess;
